import ReactDOM from "react-dom/client"
import theme from "./styles/material-theme"

// Theme
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider } from "@mui/material/styles"

// App
import App from "./App"
import ErrorBoundary from "./hooks/ErrorBoundary"
import preloadAssets from "./modules/assetsPreload"

// TODO: FIX THIS: https://stackoverflow.com/questions/62810553/how-to-fix-trustedhtml-assignment-error-with-angular-innerhtml
if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy("default", {
    createHTML: (string, sink) => string,
  })
}

preloadAssets().then(() => {
  // Initialize App
  const rootElement = document.getElementById("root")
  if (!rootElement) throw new Error("Failed to find the root element")
  const root = ReactDOM.createRoot(rootElement)

  root.render(
    <ErrorBoundary>
      {/* <React.StrictMode> */}
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
      {/* </React.StrictMode> */}
    </ErrorBoundary>
  )
})
